module.exports = __webpack_public_path__ + "img/14.19cc1731.png";